import { useScaffold } from "@Light/scaffold";
import clsx from "clsx";
import { Query } from "../app/QueryLoader";
import { Button, ButtonProps } from "./Button";

export type MutationButtonProps = ButtonProps & {
  mutation: Query;
  mutateButtonText: React.ReactNode;
  mutate?: () => void;
  errorMessage?: string;
};

export const MutationButton: React.FC<MutationButtonProps> = ({
  mutation,
  mutateButtonText,
  mutate,
  errorMessage,
  className,
  disabled,
  onClick,
  ...props
}) => {
  const scaffold = useScaffold();
  const Spinner = scaffold.system.spinner;
  const Field = scaffold.system.field;
  const ErrorMessage = scaffold.system.errorMessage;
  return (
    <div className="flex flex-col gap-2">
      {mutation.isError && errorMessage ? (
        <Field>
          <ErrorMessage>{errorMessage}</ErrorMessage>
        </Field>
      ) : null}
      <div className="flex justify-center">
        <Button
          type="submit"
          className={clsx("w-full", className)}
          onClick={mutate}
          disabled={Boolean(mutation.isLoading || disabled)}
          {...props}
        >
          {mutation.isLoading ? (
            <div className="flex items-center justify-center">
              <Spinner className="size-5" />
            </div>
          ) : (
            mutateButtonText
          )}
        </Button>
      </div>
    </div>
  );
};
